// extracted by mini-css-extract-plugin
export default {"dropzoneContainer":"dropzone_dropzoneContainer__oiF7G","textWrap":"dropzone_textWrap__Uzdph"};